var map = {
	"./Felicitation-Of-Our-Sanstha-1-300x200.jpg": 3797,
	"./Felicitation-Of-Our-Sanstha-2-300x200.jpg": 7610,
	"./Felicitation-Of-Our-Sanstha-3-300x176.jpg": 639,
	"./Felicitation-Of-Our-Sanstha-4-300x225.jpg": 8067,
	"./Felicitation-Of-Our-Sanstha-5-300x225.jpg": 6942,
	"./Felicitation-Of-Our-Sanstha-6-300x168.jpeg": 4684,
	"./Felicitation-Of-Our-Sanstha-7-135x300.jpeg": 1685,
	"./Felicitation-Of-Our-Sanstha-8-300x189.jpeg": 5539,
	"./Felicitation-Of-Our-Sanstha-9-300x190.jpeg": 1614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9019;